// extracted by mini-css-extract-plugin
export var numpadContainer = "_lh-1";
export var phoneButton = "_lh-0";